import { render, staticRenderFns } from "./offenderDetails.vue?vue&type=template&id=7b9336fc&scoped=true"
import script from "./offenderDetails.vue?vue&type=script&lang=js"
export * from "./offenderDetails.vue?vue&type=script&lang=js"
import style0 from "./offenderDetails.vue?vue&type=style&index=0&id=7b9336fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9336fc",
  null
  
)

export default component.exports